<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">权限管理</span></div>
		<div class="margin-top margin-left margin-right">
			<Button color="primary" :loading="saving" @click="save">保存全部权限</Button>
			<span class="gray-color" style="margin-left: 10px;">勾选各角色在对应模块下的操作权限（查看=GET 请求，编辑=写操作；账套管理员 Manager 恒为全部权限）</span>
		</div>
		<div class="h-panel-body">
			<table class="perm-table">
				<thead>
				<tr>
					<th class="perm-role-col">角色</th>
					<th v-for="m in modules" :key="m.key">{{ m.title }}</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="role in roles" :key="role.key">
					<td class="perm-role-col">
						<div class="perm-role-name">{{ role.title }}</div>
						<div class="perm-role-key">{{ role.key }}</div>
					</td>
					<td v-for="m in modules" :key="m.key">
						<label v-for="p in m.perms" :key="p.key" class="perm-item">
							<input type="checkbox"
								   :checked="hasPerm(role.key, m.key, p.key)"
								   @change="togglePerm(role.key, m.key, p.key)"/>
							<span>{{ p.title }}</span>
						</label>
					</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	export default {
		name: "AdminPermissionManagement",
		data() {
			return {
				loading: false,
				saving: false,
				//权限矩阵：{role: {module: ['view', ...]}}
				matrix: {},
				roles: [
					{key: 'Manager', title: '账套管理员'},
					{key: 'Director', title: '主管'},
					{key: 'Making', title: '制单人'},
					{key: 'Cashier', title: '出纳'},
					{key: 'View', title: '查看'}
				],
				//模块标识与权限点必须与后端 PermissionModules / 权限拦截器语义一致（仅 view/edit 生效）
				modules: [
					{key: 'voucher', title: '凭证', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'accountbook', title: '账簿', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'report', title: '报表', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'assets', title: '固定资产', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'invoice', title: '发票', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'tax', title: '税务', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'salary', title: '工资', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'funds', title: '资金', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'inventory', title: '进销存', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'checkout', title: '结账', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'setting', title: '设置', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'member', title: '成员', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]},
					{key: 'backup', title: '备份', perms: [{key: 'view', title: '查看'}, {key: 'edit', title: '编辑'}]}
				]
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.permissions().then(({data}) => {
					let matrix = {};
					(data || []).forEach(item => {
						if (!matrix[item.role]) {
							matrix[item.role] = {};
						}
						matrix[item.role][item.module] = (item.permissions || '').split(',').filter(Boolean);
					});
					this.matrix = matrix;
				}).finally(() => this.loading = false);
			},
			hasPerm(role, module, perm) {
				return !!(this.matrix[role] && this.matrix[role][module] && this.matrix[role][module].includes(perm));
			},
			togglePerm(role, module, perm) {
				let matrix = Object.assign({}, this.matrix);
				if (!matrix[role]) {
					matrix[role] = {};
				}
				let perms = (matrix[role][module] || []).slice();
				let index = perms.indexOf(perm);
				if (index >= 0) {
					perms.splice(index, 1);
				} else {
					perms.push(perm);
				}
				matrix[role] = Object.assign({}, matrix[role], {[module]: perms});
				this.matrix = matrix;
			},
			save() {
				let list = [];
				Object.keys(this.matrix).forEach(role => {
					Object.keys(this.matrix[role]).forEach(module => {
						list.push({
							role,
							module,
							permissions: this.matrix[role][module].join(',')
						});
					});
				});
				this.saving = true;
				this.$api.admin.savePermissions(list).then(() => {
					this.$Message.success('保存成功~');
				}).finally(() => this.saving = false);
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>

<style scoped lang="less">
	.perm-table {
		width: 100%;
		border-collapse: collapse;
		background: #fff;

		th, td {
			border: 1px solid #eaeaea;
			padding: 10px 12px;
			text-align: left;
			vertical-align: top;
			font-size: 13px;
		}

		th {
			background: #fafafa;
			font-weight: 500;
		}
	}

	.perm-role-col {
		width: 110px;
		background: #fafafa;
	}

	.perm-role-name {
		font-weight: 500;
	}

	.perm-role-key {
		color: #aaa;
		font-size: 12px;
		margin-top: 2px;
	}

	.perm-item {
		display: inline-flex;
		align-items: center;
		margin-right: 12px;
		cursor: pointer;
		white-space: nowrap;

		input {
			margin-right: 4px;
		}
	}
</style>
